var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("Not Found!")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v("Go home?")])])])
}]

export { render, staticRenderFns }